import { render } from "./newpage.vue?vue&type=template&id=f642bf10"
import script from "./newpage.vue?vue&type=script&lang=js"
export * from "./newpage.vue?vue&type=script&lang=js"

import "./newpage.css?vue&type=style&index=0&lang=css"

import exportComponent from "/Users/jinzhouhang/work/zhanhai/beautifuldai-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__